import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, renderSlot as _renderSlot, unref as _unref, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, createElementBlock as _createElementBlock } from "vue"

import BaseIcon from '@/components/BaseIcon.vue'
import BaseButton from '@/components/BaseButton.vue'
import { FORMATS, SIZES, ALERT_TYPES } from '@/enums/components'
import { PropType, computed } from 'vue'


export default /*#__PURE__*/_defineComponent({
  __name: 'AlertBanner',
  props: {
  alertType: {
    type: String as PropType<ALERT_TYPES>,
    default: ALERT_TYPES.INFO,
  },
  text: {
    type: [String, Array] as PropType<string | string[]>,
    default: '',
  },
  buttonLabel: {
    type: String,
    default: undefined,
  },
  buttonIcon: {
    type: String,
    default: null,
  },
  buttonAfterText: {
    type: Boolean,
    default: false,
  },
},
  emits: ['buttonClick'],
  setup(__props) {

const props = __props



const content = computed<string>(() => {
  if (Array.isArray(props.text)) {
    return props.text.join(' ')
  }
  return props.text
})



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["alert-banner", [`alert-banner--${__props.alertType}`]])
  }, [
    _createVNode(BaseIcon, {
      icon: __props.alertType,
      size: 24
    }, null, 8, ["icon"]),
    _createElementVNode("p", {
      class: _normalizeClass(["alert-banner__text", {
        'alert-banner__button-right': !__props.buttonAfterText,
        'alert-banner__text-with-button': !!__props.buttonLabel,
      }])
    }, [
      _renderSlot(_ctx.$slots, "content", {}, () => [
        _createTextVNode(_toDisplayString(_unref(content)), 1)
      ]),
      (__props.buttonLabel)
        ? (_openBlock(), _createBlock(BaseButton, {
            key: 0,
            label: __props.buttonLabel,
            format: _unref(FORMATS).TERTIARY,
            size: _unref(SIZES).SMALL,
            icon: __props.buttonIcon,
            type: "button",
            class: "alert-banner__button",
            onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('buttonClick')))
          }, null, 8, ["label", "format", "size", "icon"]))
        : _createCommentVNode("", true)
    ], 2)
  ], 2))
}
}

})